import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { Card, CardBody, Col, Label, Modal, Row } from 'reactstrap';
import { RootState } from '..';
import { getInputs } from './getFormValues';
import { Generic, RecordState, setRecordState } from '../Store/Generic/GenericSlice';

const ViewModel: React.FC = () => {
    const ViewRecordState: RecordState = 'VIEW';
    const { records, recordID, recordState } = useSelector((state: RootState) => state.Generic);
    const dispatch = useDispatch();
    const { masters } = useParams();
    const [viewModelState, setViewModelState] = useState(false);

    useEffect(() => {
        setViewModelState(true);
    }, [recordState]);

    if (recordState !== ViewRecordState || recordID < 0) {
        return null;
    }

    const { inputs } = getInputs(masters);
    const initialValue: Generic = { name: '' };
    const record = records.find(record => record.id === recordID) || initialValue;

    return (
        <Modal
            isOpen={viewModelState}
            toggle={() => setViewModelState(!viewModelState)}
            backdrop="static"
            id="View-records"
        >
            <div className="modal-header">
                {inputs.map(({ page_title }) => (
                    <h5 className="modal-title" key={page_title} id="staticBackdropLabel">
                        {page_title}
                    </h5>
                ))}
                <button
                    type="button"
                    className="btn-close"
                    onClick={() => dispatch(setRecordState(null))}
                    aria-label="Close"
                />
            </div>
            <div className="modal-body">
                <Card>
                    <CardBody>
                        {inputs.map(({ name, label }) => (
                            <Row key={name}>
                                <Col lg={6}>
                                    <div className="mb-3">
                                        <Label className="w_8">{label}:</Label>
                                        <Label className="w_8">{record[name]}</Label>
                                    </div>
                                </Col>
                            </Row>
                        ))}
                    </CardBody>
                </Card>
            </div>
        </Modal>
    );
};

export default ViewModel;
